module.exports = __webpack_public_path__ + "6c822a28ff22165ad7aea15a1121594d.svg";